import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from "react-router-dom";
import { bindActionCreators } from 'redux';
import {actionCreators} from "../../store/Admin";
import userManager from '../../userManager';

class ChangeCustId extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      newCustID: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount(){
    if (this.props.user) {
      if (this.props.admin.all.length === 0){
        this.props.getAllCustomers();
      }
      if (this.props.admin.current === null||
        this.props.admin.current.fileMakerId !== this.props.user.profile.cdb_custid
      ){
        this.props.getCurrentCustomer();
      }
    }
  }
  
  handleChange(event){
    if (event.target.value != null)
      this.setState({newCustID: event.target.value});
  }

  handleClick(){
    apiPutPost(this.props, this.state.newCustID).then();
  }
  
  render(){
    if (this.props.user){
      if (this.props.user.profile.cf_cdb_admin === 'true'){
        return (
          <div className="sub-nav">
            <div className="sub-nav-item">
              <p>You are looking at {this.props.admin.current ? this.props.admin.current.name : null}</p>
            </div>
            <div className="sub-nav-item">
              <select className="form-input-select" onChange={this.handleChange}>
                {(this.props.admin.all || []).map( (item) =>{
                  if (item.fileMakerId === this.props.admin.current.fileMakerId) {
                    return(
                      <option value={item.fileMakerId} key={item.fileMakerId} selected="selected">{item.name}</option>
                    );
                  }else{
                    return(
                      <option value={item.fileMakerId} key={item.fileMakerId}>{item.name}</option>
                    );
                  }

                })}
              </select>
              <button className="btn-secondary-sm" onClick={this.handleClick}>Select</button>
            </div>
          </div>
        );
      }else{
        return null;
      }
    } else {
      return null;
    }
    
  }

}
async function apiPutPost(props, id){
  const url = `api/cfadmin/changeid/${id}`;
  const path = window.location.pathname;
  
  fetch(url, {
    method: 'PUT',
    headers: new Headers({
      'Authorization': 'Bearer ' + props.user.access_token,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    })
  }).then((response) => {
    if (response.status === 200) {
      userManager.getUser().then( user => {
        userManager.signinRedirect({data: {path: window.location.pathname}})
      })
    }
  }).catch((error) =>{
      throw error;
  });
}


const mapStateToProps = function(state) {
  return {
    user: state.oidc.user,
    admin: state.admin
  }
};

//export default NavMenu;
export default withRouter(connect(mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch))(ChangeCustId));